export default __webpack_public_path__ + "static/media/uspacyLogo.1e210012.svg";